import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "../../sidebar.css";

function SidebarCategory() {
  const { menuSubMenus } = useSelector((state) => state.menu);
  return (
    <>
      <button
        type="button"
        className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
      >
        <i className="ph ph-x"></i>
      </button>

      <ul className="responsive-dropdown__list">
        {menuSubMenus.length > 0 &&
          menuSubMenus.map((menu, index) => (
            <li className="has-submenus-submenu" key={index}>
              <Link to={`/category/${menu.slug_url}`} className="menu-item">
                <span>{menu.name}</span>
                <span className="icon">
                  <i className="ph ph-caret-right"></i>
                </span>
              </Link>

              {menu.subMenu.length > 0 && (
                <div className="submenus-submenu">
                  <h6 className="submenu-title">{menu.name}</h6>
                  <ul className="submenus-submenu__list">
                    {menu.subMenu.map((subMenu, subIndex) => (
                      <li key={subIndex}>
                        <Link
                          to={`/category/${menu.slug_url}/${subMenu.slug_url}`}
                        >
                          {subMenu.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ))}
      </ul>
    </>
  );
}

export default SidebarCategory;
